import React, { FC } from "react";

import { DefaultRowControl } from "~/shared/ui/TableV2/ui/DefaultRowControl";
import { RowSelectionControl } from "~/shared/ui/TableV2/ui/RowSelectionControl";

import s from "./DirectoryRowActions.less";

interface IDirectoryRowActionsProps {
  record: Record<string, unknown>;
  rowKey: string | number;
  selectedRowKey?: string | number | null;
  onSelectRow?: (key: string | number) => void;
  showSelection?: boolean;
  onRowEdit?: (record: Record<string, unknown>) => void;
  onRowDelete?: (record: Record<string, unknown>) => void;
}

const DirectoryRowActions: FC<IDirectoryRowActionsProps> = ({
  record,
  rowKey,
  selectedRowKey,
  onSelectRow,
  showSelection = false,
  onRowEdit,
  onRowDelete,
}) => (
  <div className={s.directoryRowActions}>
    {showSelection && (
      <RowSelectionControl
        checked={selectedRowKey === rowKey}
        onChange={() => onSelectRow?.(rowKey)}
      />
    )}
    <DefaultRowControl
      record={record}
      onRowEdit={onRowEdit}
      onRowDelete={onRowDelete}
    />
  </div>
);

export default DirectoryRowActions;
